import React, { useRef } from "react"
import { Index } from "elasticlunr"
import { connect } from "react-redux"
import searchIcon from "../../images/SearchIcon.png"

import { SearchBarWrapper } from "../styled"

import searchBarX from "../../images/searchbarx.png"

import { updateQuery, updateResults, toggleExpanded } from "../../actions"

const SearchBar = ({
  toggleLogoVisible,
  searchIndex,
  query,
  expanded,
  logoVisible,
  searchVisible,
  updateQuery,
  toggleExpanded,
  updateResults,
}) => {
  const searchBarInput = useRef(null)

  const handleClick = () => {
    updateQuery("")
    toggleLogoVisible(!logoVisible)
    toggleExpanded(!expanded)
  }

  const handleFocus = () => {
    if (!expanded) {
      toggleLogoVisible(!logoVisible)
      toggleExpanded(!expanded)
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault()
  }

  const search = (e) => {
    const newQuery = e.target.value.toLowerCase()
    updateQuery(newQuery)
    updateResults([])

    if (newQuery.length > 3) {
      const index = Index.load(searchIndex)
      // elasticlunr version does not work with partial words, eg `obgyn-developed`? https://nutrafol.atlassian.net/browse/NT2-9607
      // const resultsE = index.search(newQuery, {expand: true}).map(({ ref }) => index.documentStore.getDoc(ref))
      let results = []
      const docs = index.documentStore.docs
      let doc
      for (let key in docs) {
        doc = docs[key]
        console.log("doc ", doc)
        const tags = doc.tags.map((el) => el.toLowerCase())
        if (doc.title.toLowerCase().indexOf(newQuery) > -1) {
          results.push(doc)
        }
        if (tags.includes(newQuery)) {
          results.push(doc)
        }
      }
      // remove duplicates
      results = results
        .filter(
          (obj1, i, arr) =>
            arr.findIndex((obj2) => obj2.uniqueID === obj1.uniqueID) === i
        )
        .filter((item) => item.uniqueID !== "do-not-delete")
      updateResults(results)
    }
  }

  const focusSearchInput = () => {
    searchBarInput.current.focus()
  }

  return (
    <>
      {searchVisible && (
        <SearchBarWrapper
          onSubmit={handleSubmit}
          className={expanded ? "expanded" : ""}
        >
          <img
            className="search-icon"
            src={searchIcon}
            alt="open search bar"
            onClick={focusSearchInput}
          />
          <input
            id={`search-bar-input`}
            value={query}
            onChange={search}
            className={
              !expanded ? "searchbar-input" : "searchbar-input expanded-input"
            }
            placeholder="Search"
            ref={searchBarInput}
            tabIndex={2}
            onFocus={handleFocus}
          />
          <img
            className="search-x"
            src={searchBarX}
            alt="close button"
            style={{ display: expanded ? "block" : "none" }}
            onClick={handleClick}
            onKeyPress={handleClick}
            tabIndex={2}
          />
        </SearchBarWrapper>
      )}
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    query: state.queryReducer.query,
    expanded: state.searchBarExpandedReducer.expanded,
    logoVisible: state.logoVisibleReducer.logoVisible,
    searchVisible: state.searchVisibleReducer.searchVisible,
  }
}

export default connect(mapStateToProps, {
  updateQuery,
  toggleExpanded,
  updateResults,
})(SearchBar)
